var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.256,
    height: 13.571,
    viewBox: "0 0 14.256 13.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M7.152,13.571h0l-.185-.115a27.269,27.269,0,0,1-4.54-3.543A9.293,9.293,0,0,1,.28,6.486a5.543,5.543,0,0,1,.1-3.768A4.338,4.338,0,0,1,3.082.193,3.177,3.177,0,0,1,3.716.043H3.8A4.1,4.1,0,0,1,4.4,0h.078A4.473,4.473,0,0,1,5.784.236h.042A.263.263,0,0,1,5.89.278a2.516,2.516,0,0,1,.449.186l.27.122a1.876,1.876,0,0,1,.207.137c.039.029.073.053.1.07l.035.02A1.653,1.653,0,0,1,7.13.928,4.431,4.431,0,0,1,9.843,0h.032A4.161,4.161,0,0,1,11.2.207,4.3,4.3,0,0,1,13.877,2.72a5.662,5.662,0,0,1,.11,3.766A9.134,9.134,0,0,1,11.842,9.92a27.534,27.534,0,0,1-4.513,3.543l-.177.108Zm3.5-11.344a.578.578,0,0,0-.54.388.586.586,0,0,0,.357.735,1.2,1.2,0,0,1,.763,1.122v.022a.614.614,0,0,0,.136.443.6.6,0,0,0,.406.207.587.587,0,0,0,.563-.543V4.514a2.359,2.359,0,0,0-1.5-2.257A.554.554,0,0,0,10.649,2.227Z",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_to_wishlist",
    "data-name": "add to \\u2764\\uFE0F wishlist",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-1.423 -1.786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color_errors",
    "data-name": "color/errors",
    width: 73.315,
    height: 73.464,
    rx: 4,
    fill: "#bdc6d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.cb16b7f38d8ebd6381fbfb3a5a0f0a5c.svg";
export { ForwardRef as ReactComponent };